import { useQuery } from '@tanstack/react-query';
import ProjectMember, { ProjectMemberJSON } from '../models/projectMember';
import useProjectMembersSystem from '../system/useProjectMembersSystem';
import { QueryKeys } from './keysAndFilters';
import { DEFAULT_QUERY_OPTIONS } from '../../projects/queries/constants';

const allProjectMembersFromJson = ( membersJson: ProjectMemberJSON[] ) => (
	membersJson.map( ProjectMember.fromJson )
);

const useFetchProjectMembersQuery = ( { projectID }: { projectID: number } ) => {
	const system = useProjectMembersSystem();

	return useQuery(
		QueryKeys.forProjectMembers( { projectID } ),
		() => system.fetchProjectMembers( { projectID } ),
		{
			...DEFAULT_QUERY_OPTIONS,
			select: allProjectMembersFromJson
		}
	);
};

export default useFetchProjectMembersQuery;
